import { useMutation, useQueryClient } from 'react-query';
import { BillingApi } from 'app/modules/settings/modules/billing/api/billing';
import {
  AttachStripePaymentMethodRequest,
  PaymentMethodResponse,
} from 'app/modules/settings/modules/billing/types';
import { invalidateBillingCaches } from 'app/modules/settings/modules/billing/utils/billingCaches';

export type AttachStripeVars = {
  body: AttachStripePaymentMethodRequest;
  idempotencyKey: string;
};

export const useAttachStripePaymentMethod = () => {
  const queryClient = useQueryClient();
  return useMutation<PaymentMethodResponse, unknown, AttachStripeVars>(
    ({ body, idempotencyKey }) =>
      BillingApi.attachStripePaymentMethod(body, idempotencyKey),
    {
      onSuccess: () => {
        invalidateBillingCaches(queryClient);
      },
    },
  );
};
